import { motion } from "framer-motion";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import { PROCESS } from "../../data/content";

export function ProcessTimeline() {
  return (
    <>
      <div className="relative hidden lg:block">
        <div className="absolute left-0 right-0 top-7 h-px bg-[#111827]/10" />
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          className="absolute left-0 right-0 top-7 h-px origin-left bg-gradient-to-r from-[#1677FF] to-[#00C7D9]"
        />
        <div className="relative grid grid-cols-5 gap-6">
          {PROCESS.map((step, i) => (
            <Reveal key={step.no} index={i}>
              <div className="flex flex-col items-start">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-[#1677FF]/30 bg-white text-sm font-bold text-[#1677FF] shadow-sm">
                  {step.no}
                </span>
                <h3 className="mt-6 text-lg font-bold text-[#111827]">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4B5563]">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="relative lg:hidden">
        <div className="absolute bottom-4 left-[27px] top-4 w-px bg-[#111827]/10" />
        <div className="space-y-8">
          {PROCESS.map((step, i) => (
            <Reveal key={step.no} index={i} className="relative flex gap-5">
              <span className="relative z-10 flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border border-[#1677FF]/30 bg-white text-sm font-bold text-[#1677FF] shadow-sm">
                {step.no}
              </span>
              <div className="pt-1">
                <h3 className="text-lg font-bold text-[#111827]">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4B5563]">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </>
  );
}

export default function ProcessSection() {
  return (
    <section className="ad-section bg-white" data-testid="process-section">
      <div className="ad-container">
        <SectionHeading eyebrow="Our Process" title={<>From challenge to <span className="text-gradient">measurable outcome.</span></>} />
        <div className="mt-16"><ProcessTimeline /></div>
      </div>
    </section>
  );
}
